import React from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import theme from "../../../Theme";
import GCTitleSticky from "./GCTitleSticky";
import useMediaQuery from "@mui/material/useMediaQuery"; 
const CmpModal = ({
  open = false,
  onClose = () => {},
  title = "",
  component,
  height = "",
  width = "",
}) => {
   const vMediaQuery = useMediaQuery("(max-width:650px)");
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{ flexGrow: 1, overflow: "auto", width:width }} className="model-cmpModal">
        <div className="cmpModal-head">
          <Typography variant="subtilte1" sx={{ margin: 0, fontSize: "14px" }}>
            {title}
          </Typography>
          <IconButton onClick={onClose} sx={{ cursor: "pointer" }}>
            <CloseIcon />
          </IconButton>
        </div>

        <Box sx={{ height: height, overflowY: "auto", p:vMediaQuery? 1.5 : 3 }}>{component}</Box>
      </Box>
    </Modal>
  );
};

export default CmpModal;
